module.exports = __webpack_public_path__ + "img/Bridge-Framework.959135a8.jpg";